

import React from "react";

function Beta() {
  return (
    <main className="page">
      <section className="content-page">
        <div className="content-card">
          <div className="card-header">
            <span className="page-badge">ASDRY BETA</span>
            <h1 className="page-title">ASDRY Beta is live</h1>
          </div>

          <div className="card-body">
            <p>
              ASDRY Beta is focused on helping people understand what weather and
              environmental conditions may mean for the activity they are planning.
            </p>

            <p>
              Rather than simply displaying forecast data, ASDRY aims to provide
              practical preparation guidance that helps users understand what to
              expect, what to watch out for, and how conditions may affect their
              plans.
            </p>

            <h2 className="content-subtitle">Activities currently being tested</h2>

            <ul>
              <li>Running</li>
              <li>Walking</li>
              <li>Commuting</li>
              <li>Cycling</li>
              <li>Dog walking</li>
              <li>Gardening</li>
              <li>Hanging washing outdoors</li>
              <li>General outdoor activities</li>
            </ul>

            <h2 className="content-subtitle">Built through real-world testing</h2>

            <p>
              ASDRY is being developed through everyday activity testing, user
              feedback, and Parkrun field testing. The goal is to learn what people
              actually find useful when weather affects real plans.
            </p>

            <h2 className="content-subtitle">Help shape ASDRY</h2>

            <p>
              Feedback is one of the most important parts of the beta programme.
              User feedback helps identify where guidance is useful, where it can be
              improved, and what future features should be prioritised.
            </p>

            <h2 className="content-subtitle">Future plans</h2>

            <p>
              The current focus is improving the Free Beta experience. Additional
              planning features, Pro options, Business tools, and API capabilities
              are being explored and may evolve as testing continues.
            </p>

            <div className="cta-row">
              <a href="https://asdry.app" className="home-primary">
                Try ASDRY Beta →
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Beta;